import React from 'react';

const Error404 = () => {
    return ( <></> );
}
 
export default Error404;